import { ACCOUNT_TYPES_MAP } from '@linearb/linjs-common';

export const isAdmin = account =>
  account?.type_id === ACCOUNT_TYPES_MAP.Primary;

export const isSuperUser = account =>
  account?.type_id === ACCOUNT_TYPES_MAP.SuperUser;

export const isViewer = account =>
  account?.type_id === ACCOUNT_TYPES_MAP.Viewer;
